function upper(value: string) {
  return value.charAt(0)
    .toUpperCase() + value.slice(1);
}

export default upper;